import React, { createContext, useCallback, useContext, useRef, useState } from "react";
import { AlertCircle, CheckCircle2, Info } from "lucide-react";

const ToastContext = createContext(() => {});

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const show = useCallback((text, kind = "info") => {
    // Locked premium actions already open the paywall — don't stack an error toast on top
    if (kind === "error" && String(text).startsWith("Continue with LOVE NET Premium")) return;
    if (timer.current) clearTimeout(timer.current);
    setToast({ id: Date.now(), text, kind });
    timer.current = setTimeout(() => setToast(null), 3200);
  }, []);
  const bg = toast?.kind === "success" ? "bg-[#3A6C54]" : toast?.kind === "error" ? "bg-[#9E3C3E]" : "bg-[#2A2727]";
  const Icon = toast?.kind === "success" ? CheckCircle2 : toast?.kind === "error" ? AlertCircle : Info;
  return (
    <ToastContext.Provider value={show}>
      {children}
      <div aria-live="polite" className="pointer-events-none fixed inset-x-0 top-4 z-[100] flex justify-center px-4">
        {toast ? (
          <div key={toast.id} data-testid="toast-message" data-kind={toast.kind} className={`fade-up flex max-w-md items-center gap-2.5 rounded-2xl px-4 py-3 text-sm font-medium text-white shadow-xl ${bg}`}>
            <Icon className="h-5 w-5 shrink-0" />{toast.text}
          </div>
        ) : null}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
